module.exports = __webpack_public_path__ + "fonts/museo-sans-700-webfont.c8c2287.woff2";